import { useState } from 'react'
import { useToast } from '@/context/ToastContext'
import { AccountService } from '@common/services/account-service'

const accountService = new AccountService()

export const useForgotPassword = () => {
  const [showModal, setShowModal] = useState(false)
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { showErrorMessage } = useToast()

  const openModal = (initialEmail = '') => {
    setEmail(initialEmail)
    setSuccess(false)
    setError(null)
    setShowModal(true)
  }

  const closeModal = () => {
    setShowModal(false)
    setEmail('')
    setSuccess(false)
    setError(null)
  }

  const sendResetEmail = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    const trimmed = email.trim()
    if (!trimmed) {
      setError('メールアドレスを入力してください')
      return
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setError('メールアドレスの形式が正しくありません')
      return
    }

    setIsLoading(true)
    try {
      await accountService.requestPasswordReset(
        trimmed,
        `${window.location.origin}/reset-password`,
      )
      setSuccess(true)
    } catch (err: unknown) {
      const code = (err as { code?: string })?.code
      const message = (err as { message?: string })?.message ?? ''
      if (code === 'invalid-argument') {
        setError(message || 'メールアドレスを正しく入力してください')
      } else {
        console.error('Password reset request error:', err)
        setError('送信に失敗しました。しばらく経ってからお試しください。')
        showErrorMessage('送信に失敗しました。しばらく経ってからお試しください。')
      }
    } finally {
      setIsLoading(false)
    }
  }

  return {
    showModal,
    openModal,
    closeModal,
    email,
    setEmail,
    sendResetEmail,
    isLoading,
    success,
    error,
  }
}
